var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('MapIcon',_vm._b({attrs:{"count":0,"label":_vm.label,"size":_vm.size}},'MapIcon',_vm.icon.value,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }